details summary::-webkit-details-marker {
  display: none;
}
